<template>
  <div class="app-wrapper" :class="classObj">
    <sidebar class="sidebar-container"></sidebar>
    <div class="main-scroll-container">
      <div class="main-scroll-content">
        <div class="fixed-header">
          <navbar ref="navbar"></navbar>
        </div>
        <div class="main-container">
          <app-main @ContactSeller="ContactSeller"></app-main>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Navbar, Sidebar, AppMain} from './components'
import ResizeMixin from './mixin/ResizeHandler'

export default {
  name: 'layout',
  components: {
    Navbar,
    Sidebar,
    AppMain
  },
  mixins: [ResizeMixin],
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar
    },
    device() {
      return this.$store.state.app.device
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    }
  },
  methods: {
    ContactSeller(e, nickname) {
      this.$refs.navbar.goNewWindow(e, nickname)
    },
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "src/styles/mixin.scss";

.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue